module.exports = __webpack_public_path__ + "img/vue-logo.f21685ba.png";